export function notificationStore() {
  return {
    state: {
      displayed: false,
      icon: null,
      message: [],
    },

    getters: {
      getNotificationDisplayed(state) {
        return state.displayed;
      },
      getNotificationIcon(state) {
        return state.icon;
      },
      getNotificationMessage(state) {
        return state.message;
      },
    },

    mutations: {
      setDisplayed(state, displayed) {
        state.displayed = displayed;
      },
      setIcon(state, icon) {
        state.icon = icon;
      },
      setMessage(state, message) {
        state.message = message;
      },
    },

    actions: {
      showNotification({ commit }, { icon, message }) {
        commit('setIcon', icon);
        commit('setMessage', message);
        commit('setDisplayed', true);
      },

      hideNotification({ commit }) {
        commit('setDisplayed', false);
        commit('setIcon', null);
        commit('setMessage', []);
      },
    },
  };
}

export default notificationStore();
